import React, {useContext} from "react";
import {DynamicComponentProps} from "../../core/_models";

export function FileInputComponent({config, context}: DynamicComponentProps) {
    const {value, title, readOnly, id, action} = config;

    const formContext = useContext(context);

    const encodeImageFileAsURL = (element: HTMLInputElement) => {
        if (element.files == null) {
            return;
        }

        const file = element.files[0];
        const reader = new FileReader();
        reader.onloadend = function () {
            const {result} = reader;

            if (action != null) {
                const values: { [key: string]: any } = {};
                values[id] = result;
                formContext.submit({action, values})
            } else {
                formContext.set(id, result);
            }
        }
        reader.readAsDataURL(file);
    }

    return (
        <div>
            {value && <a
                className='btn btn-primary'
                href={value}
                target='_blank'
            >
                {title || 'Preview'}
            </a>}
            {!readOnly &&
                <div className="py-2"><input type="file" onChange={(e) => encodeImageFileAsURL(e.target)}/></div>}
        </div>
    );
}